import { useState } from "react";
import Marquee from "react-fast-marquee";
import { Pause, Play } from "lucide-react";

// Real client logos (uploaded assets) — 9 total
const logoClients = [
  {
    name: "Arcadia Books",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/o1oi8gc4_arc_logo_marineblue_olive.png",
  },
  {
    name: "Rudolf Steiner Press",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/rgntm27y_download%20%281%29.jpg",
  },
  {
    name: "Kalimat Press",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/efk2jf18_download%20%282%29.jpg",
  },
  {
    name: "Temple Lodge Publishing",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/bxbu1e4a_templelodge.png",
  },
  {
    name: "Clairview",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/ziywim7z_clv_vertical.jpg",
  },
  {
    name: "DCL",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/vnloziaw_DCL-LLC-logo-300w.avif",
  },
  {
    name: "Edcon Publishing",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/pp2zue06_EDCON-logo-333x77.png",
  },
  {
    name: "Bubok",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/medthp9u_logo.png",
  },
  {
    name: "Logictran Inc",
    src: "https://customer-assets.emergentagent.com/job_accessibility-first-5/artifacts/ojc6s6pw_logictran_inc_logo.jpg",
  },
];

// Remaining clients without uploaded assets — skipped per user request
const textClients = [];

function LogoChip({ name, src }) {
  return (
    <div
      data-testid={`client-logo-${name.toLowerCase().replace(/\s+/g, "-")}`}
      className="group mx-4 h-24 w-60 sm:w-72 rounded-2xl bg-white border border-[#0B1F3A]/10 flex items-center justify-center px-6 py-4 transition-all duration-300 hover:border-[#1F5EFF]/40 hover:shadow-[0_18px_40px_-24px_rgba(11,31,58,0.35)]"
      title={name}
    >
      <img
        src={src}
        alt={name}
        loading="lazy"
        className="max-h-16 max-w-full w-auto object-contain transition-all duration-300 client-logo-tint group-hover:client-logo-color"
      />
    </div>
  );
}

function TextChip({ name }) {
  const parts = name.split(" ");
  const mono = parts.length === 1 ? parts[0].slice(0, 2) : parts[0][0] + parts[1][0];
  return (
    <div
      data-testid={`client-logo-${name.toLowerCase().replace(/\s+/g, "-")}`}
      className="group mx-4 h-20 w-48 sm:w-56 rounded-2xl bg-white border border-[#0B1F3A]/10 flex items-center justify-center gap-3 px-5 transition-all duration-300 hover:border-[#1F5EFF]/40 hover:shadow-[0_18px_40px_-24px_rgba(11,31,58,0.35)]"
    >
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#0B1F3A] text-white font-display font-bold text-[12px] tracking-tight transition-colors group-hover:bg-[#1F5EFF]">
        {mono.toUpperCase()}
      </span>
      <span className="font-display font-semibold text-[#0B1F3A] text-[14px] whitespace-nowrap tracking-tight">
        {name}
      </span>
    </div>
  );
}

export default function Clients() {
  const [playing, setPlaying] = useState(true);
  return (
    <section id="clientele" data-testid="clients-section" className="relative py-20 bg-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="overline">Trusted by</div>
          <h2 className="mt-3 font-display text-2xl sm:text-3xl font-bold text-[#0B1F3A] tracking-tighter">
            Publishers and content innovators worldwide.
          </h2>
        </div>

        <div className="marquee-fade" aria-hidden="true">
          <Marquee gradient={false} speed={36} pauseOnHover play={playing}>
            {logoClients.map((c) => (
              <LogoChip key={c.name} name={c.name} src={c.src} />
            ))}
            {textClients.map((c) => (
              <TextChip key={c} name={c} />
            ))}
          </Marquee>
        </div>
        <div className="mt-5 flex justify-center">
          <button
            data-testid="marquee-pause-toggle"
            type="button"
            onClick={() => setPlaying((p) => !p)}
            aria-pressed={!playing}
            className="inline-flex items-center gap-2 rounded-full border border-[#0B1F3A]/15 bg-white px-4 py-2 text-[13px] font-semibold text-[#0B1F3A] hover:border-[#1F5EFF]/40 hover:text-[#1F5EFF] transition-colors"
          >
            {playing ? <Pause className="h-3.5 w-3.5" aria-hidden="true" /> : <Play className="h-3.5 w-3.5" aria-hidden="true" />}
            {playing ? "Pause logo animation" : "Play logo animation"}
          </button>
        </div>
        <ul className="sr-only">
          {logoClients.map((c) => (
            <li key={c.name}>{c.name}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
